module.exports = __webpack_public_path__ + "static/Ecotrail2-4f7130b4eaa75f81f10aa019a6f7eba1.png";